import type { DiagnosisReadDTO } from '../generated/api-client';

export interface AuthUserLike {
  id?: string;
  role?: string;
}

export interface DiagnosisLike {
  responsible_01?: string;
  responsible_02?: string | null;
  responsible_03?: string | null;
}

export const canEditDiagnosis = (
  user: AuthUserLike | null | undefined,
  diagnosis: DiagnosisLike | DiagnosisReadDTO | null | undefined
): boolean => {
  if (!user?.id || !diagnosis) return false;
  if (user.role === 'admin' || user.role === 'mantainer') return true;
  const referents = [
    diagnosis.responsible_01,
    diagnosis.responsible_02,
    diagnosis.responsible_03,
  ].filter(Boolean);
  return referents.includes(user.id);
};
